/* ----------------------------------------------------------------------------------------------------------------
   PJNY COLOR SWATCHES
   Hovering (or focusing) a color dot on a product card swaps the card image to that color.
   Clicking it goes to that color's product page — the link handles that on its own.
   ---------------------------------------------------------------------------------------------------------------- */

(function () {
  if (window.pjnyColorSwatchesReady) return;
  window.pjnyColorSwatchesReady = true;

  function cardFor(element) {
    return element.closest('product-card, .product-card');
  }

  function preview(card, handle) {
    var images = card.querySelectorAll('.product-card__image--color');
    var matched = false;

    for (var i = 0; i < images.length; i++) {
      if (images[i].getAttribute('data-color-handle') === handle) {
        images[i].setAttribute('data-active', '');
        matched = true;
      } else {
        images[i].removeAttribute('data-active');
      }
    }

    card.classList.toggle('is-color-preview', matched);
  }

  function clear(card) {
    var images = card.querySelectorAll('.product-card__image--color[data-active]');

    for (var i = 0; i < images.length; i++) {
      images[i].removeAttribute('data-active');
    }

    card.classList.remove('is-color-preview');
  }

  function onEnter(event) {
    if (!event.target || !event.target.closest) return;

    var swatch = event.target.closest('[data-color-swatch]');
    if (!swatch) return;

    var card = cardFor(swatch);
    if (card) preview(card, swatch.getAttribute('data-color-swatch'));
  }

  function onLeave(event) {
    if (!event.target || !event.target.closest) return;

    var list = event.target.closest('[data-color-swatch-list]');
    if (!list) return;
    if (event.relatedTarget && list.contains(event.relatedTarget)) return;

    var card = cardFor(list);
    if (card) clear(card);
  }

  document.addEventListener('pointerover', onEnter, { passive: true });
  document.addEventListener('pointerout', onLeave, { passive: true });
  document.addEventListener('focusin', onEnter);
  document.addEventListener('focusout', onLeave);
})();
